import { FormControl, FormHelperText, Stack } from '@mui/material';
import { MuiColorInput } from 'mui-color-input';
import React from 'react';
import { useTranslation } from '../../../contexts/TranslationContext';
import { FormFieldProps } from './index';
import { useFormErrors } from '../../../contexts/FormContext';

export default function ColorFormField({
    name,
    label,
    required,
    disabled,
    value,
    onChange,
    onKeyUp,
}: FormFieldProps) {
    const { translate } = useTranslation();

    const { error } = useFormErrors(name);

    return (
        <FormControl fullWidth>
            <Stack spacing={0.5}>
                <MuiColorInput
                    name={name}
                    label={translate(label)}
                    InputLabelProps={{
                        sx: { lineHeight: 1, color: 'text.secondary', mt: 0.5 },
                    }}
                    value={value}
                    variant="outlined"
                    onChange={onChange}
                    onKeyUp={onKeyUp}
                    error={Boolean(error)}
                    required={required}
                    disabled={disabled}
                    format="hex"
                    isAlphaHidden
                />
                {Boolean(error) && (
                    <FormHelperText error id={name + '-error'}>
                        {translate(error ?? 'error')}
                    </FormHelperText>
                )}
            </Stack>
        </FormControl>
    );
}
